var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.paragraph),function(part,partKey){return _c('span',{key:("part-" + partKey)},[(_vm.isLink(part))?[_c('a',{attrs:{"target":"_","href":part.link}},[_vm._v(_vm._s(part.text))])]:(_vm.isRouterLink(part))?[_c('router-link',{attrs:{"to":{
        name: part.componentName,
        params: part.params
      }}},[_vm._v("\n        "+_vm._s(part.text)+"\n      ")])]:[_vm._v(_vm._s(part))]],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }